module.exports = __webpack_public_path__ + "img/ps.5ce6cd72.svg";